export const CLASSES_APPLY_ACTIVE: { [x: string]: string } = {
  module: '.module',
  element: '.elm',
};

export const EDITOR_KEYS = ['heading', 'text-block'];

export const ACTIVE_CLASSES = 'gf-element-active';

export const SIDEBAR_ACTIVE_CLASS = 'gf-element-active';

export const ACTIVE_FIND_POSITION = {
  NEXT: 'next',
  PREVIOUS: 'previous',
  PARENT: 'parent',
  CHILDREN: 'children',
};
